export default class MapLibrary {

    static DefaultViewport = {
        center: [46.897753, -96.802437],
        zoom: 15,
    };

    static PlotStates = {
        none: 0,
        startpoint: 1,
        endpoint: 2,
        waypoint: 3,
        measureTool: 4,
        singlepoint: 5
    };

    static boundedPadding() {
        if (window.mobileAndTabletcheck()) {
            return [0, 0];
        }
        else {
            return [400, 200];
        }
    }

    static gBoundedPadding() {
        if (window.mobileAndTabletcheck()) {
            return 0;
        }
        else {
            return 200;
        }
    }

    /**
     * Prepare the line string to be used in SQL.
     * @param {any} data
     */
    static decodeRouteData(data) {
        var encodedPolyline = data.routes[0].overview_polyline, decodedPolyline;
        decodedPolyline = window.polyline.decode(encodedPolyline);

        // convert this to a single line string for geography.
        var stringArray = decodedPolyline.toString().split(',');
        var line = "";

        for (var i = 0; i < stringArray.length; i += 2) {
            // eslint-disable-next-line
            var a = stringArray[i + 1] + " " + stringArray[i];
            if (i === stringArray.length - 2) {
                line += stringArray[i + 1] + " " + stringArray[i];
            }
            else {
                line += stringArray[i + 1] + " " + stringArray[i] + ", ";
            }
        }

        // routeEventModel.routeEvent = JSON.stringify(decodedPolyline);
        //routeEventModel.routeEvent = line;
        return {
            line: line, decodedString: decodedPolyline
        };
    }

    static decodeDetailedRouteData(data) {
        let detailedPolyline = [];
    
        // Iterate over each leg and step in the route.
        data.routes[0].legs.forEach(leg => {
            leg.steps.forEach(step => {
                // Decode the polyline for each step and add it to the detailedPolyline array.
                var stepPolyline = window.polyline.decode(step.polyline.points);
                detailedPolyline = detailedPolyline.concat(stepPolyline);
            });
        });
    
        // Convert the detailed polyline to a single line string for geography.
        var line = "";
        detailedPolyline.forEach((point, index) => {
            var pointString = point[1] + " " + point[0]; // Flip coordinates to "longitude latitude".
            if (index !== detailedPolyline.length - 1) {
                line += pointString + ", ";
            } else {
                line += pointString; // Do not add a comma after the last point.
            }
        });
    
        return {
            line: line,
            decodedString: detailedPolyline
        };
    }
    

    /**
     * Measures the distance between two points on the Earth.
     * @param {any} lat1 point 1
     * @param {any} lon1 point 1
     * @param {any} lat2 point 2
     * @param {any} lon2 point 2
     */
    static distance(lat1, lon1, lat2, lon2) {
        var R = 6371;
        var dLat = (lat2 - lat1) * Math.PI / 180;
        var dLon = (lon2 - lon1) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return Math.round(d * 3280.84) + " ft.";
    }


    static createPolyLine(startLatLng, waypoints, endpoint) {
        let polyLines = [[startLatLng.lat, startLatLng.lng]];
        polyLines = polyLines.concat(waypoints);
        polyLines.push(endpoint);

        return polyLines;
    }

    static createPolyLineStd(startLatLng, waypoints, endpoint) {
        let polyLines = [startLatLng];
        polyLines = polyLines.concat(waypoints);
        polyLines.push(endpoint);

        return polyLines;
    }

    /**
     * Takes in a points array from gson and converts them to a google maps friendly thing.
     * @param {any} points
     */
    static convertToRouteString(points) {
        let routeLine = [];
        for (let p of points) {
            routeLine.push(`${p.x},${p.y}`);
        }

        return routeLine;
    }

    static convertToRouteLatLngArray(points) {
        let routeLine = [];

        for (let p of points) {
            routeLine.push([p.x, p.y]);
        }

        return routeLine;
    }


    static convertArrayToLatLng(array) {
        return array.map((p) => { return { lat: p[0], lng: p[1] } });
    }

    static convertLatLngToArray(latlngPairs) {
        return latlngPairs.map((p) => { return [ p.lat, p.lng ] });
    }
}




// WEBPACK FOOTER //
// ./src/maps/map-lib.js